import cx from "classnames";
import { graphql } from "gatsby";
import React from "react";
import {
  PromoCardHeroImageFragment,
  PromoCardTeaserImageFragment,
} from "../../graphql-types";
import Image from "./GatsbyImage";
import InternalLink from "./InternalLink";

type Props = {
  asset: PromoCardHeroImageFragment | PromoCardTeaserImageFragment;
  href: string;
  title: string;
  imagePaddingY?: string;
};

/**
 * A clickable card with an image that links to an internal page.
 */
export default function PromoCard({
  asset: { description, gatsbyImageData },
  href,
  title,
  imagePaddingY = "0",
}: Props) {
  return (
    <li
      className={cx(
        "mx-2 mb-4 bg-white rounded-lg drop-shadow-[0_10px_5px_rgba(0,0,0,0.1)] shadow", // Default styles
        "flex-basis-full", // xs & sm screen
        "md:[flex-basis:calc(50%-1rem)]", // md screen
        "lg:[flex-basis:calc(33.3%-1rem)] lg:max-w-xs" // lg screen
      )}
    >
      <InternalLink href={href} className="flex flex-col">
        <div className={`py-${imagePaddingY}`}>
          <Image
            alt={""}
            className="mx-auto rounded-t-lg"
            image={gatsbyImageData}
          />
        </div>
        <span className="text-center promo-title p-5">{title}</span>
      </InternalLink>
    </li>
  );
}

export const fragments = graphql`
  # We display hero images at 16:9 aspect ratio as there's many combinations of
  # ratio in CTF, but this keeps the UI uniform and all the images line up.
  fragment PromoCardHeroImage on Asset {
    description
    gatsbyImageData(aspectRatio: 1.77, width: 512)
  }
  # We display teaser images always at their original aspect ratio as the assumption
  # is that they always have a consistent ratio in CTF. This way we do not get the
  # bug whereby the top and bottom of images are cropped if they're not 16:9.
  fragment PromoCardTeaserImage on Asset {
    description
    gatsbyImageData(layout: CONSTRAINED, width: 512)
  }
`;
